import { Deposit } from "@/models/base/deposit";

export class SaleEditStateLoadDepositsData {
	public modal:boolean = false;
	public foundDeposits:Deposit[] = [];
	public selectedDeposits:Deposit[] = [];
}